export default {
    notificationsPanelOpen: false,
    notifications: [],
    notificationsNextPageToken: null,
};
